<template>
  <v-container fluid>
    <PageHeader no-padding icon="assignment" />
    <Subheader v-model="search" title="Analytes" search="analytes" />
    <v-card>
      <v-data-table :headers="headers" :items="MasterAnalyteList" :pagination.sync="pagination" :search="search">
        <template v-slot:items="props">
          <td class="text-xs-left keep_space">{{props.item.Name}}</td>
          <td>{{props.item.Description}}</td>
          <td class="text-xs-right">
            <v-btn small :to="{name: 'AnalyteDetailManage', params:{ analyteId:props.item.Id.toString() }}">
              {{ $t('Button.View') }}
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import PageHeader from '@/components/generic/PageHeader'
  import Subheader from '@/components/generic/Subheader'
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import {
    sortId,
  } from '@/helpers/sorting'

  const analyte = createNamespacedHelpers('analyte')
  const authenticate = createNamespacedHelpers('authenticate')

  export default {
    components: {
      Subheader,
      PageHeader,
    },
    data() {
      return {
        search: '',
        headers: [{
          text: 'Analyte',
          value: 'Name',
          align: 'left',
        },
        {
          text: 'Problem',
          value: null,
          align: 'left',
        },
        {
          text: 'Action',
          value: null,
          align: 'right',
        },
        ],
        pagination: {
          sortBy: 'Name',
          rowsPerPage: 10,
        },
        MasterAnalyteList: [],
      }
    },
    computed: {
      ...authenticate.mapGetters(['currentUserGroup']),
    },
    mounted() {
      this.fetchAnalyteCheckingData()
    },
    methods: {
      ...analyte.mapActions(['analyteChecking']),
      fetchAnalyteCheckingData() {
        let options = {
          data: {
            TenantId: this.currentUserGroup.id,
          },
          success: (res) => {
            this.problematicAnalyteList(res)
          },
          fail: () => {},
        }
        this.analyteChecking(options)
      },
      problematicAnalyteList(data) {
        let newList = []
        data.AnalyteNoAlias.forEach(x => {
          newList.push({
            Id: x.Id,
            Name: x.Name,
            Description: this.$t('AnalyteManageError.analyteWithoutAliasDescription'),
          })
        })
        data.AnalyteNoApplicableUnitGroup.forEach(x => {
          newList.push({
            Id: x.Id,
            Name: x.Name,
            Description: this.$t('AnalyteManageError.analyteWithoutDefaultUnitGroupDescription'),
          })
        })
        data.AnalyteNoDefaultUnit.forEach(x => {
          newList.push({
            Id: x.Id,
            Name: x.Name,
            Description: this.$t('AnalyteManageError.analyteWithoutDefaultUnitDescription'),
          })
        })
        data.AnalyteUnitNotMatchUnitGroup.forEach(x => {
          newList.push({
            Id: x.Id,
            Name: x.Name,
            Description: this.$t('AnalyteManageError.analyteUnitNotMatchUnitGroupDescription'),
          })
        })
        data.AnalyteGuidelineLinkHaveMismatchedUnitGroup.forEach(x => {
          let description = this.$t('AnalyteManageError.analyteGuidelineLinkHaveMismatchedUnitGroupDescription',{ guidelineShortName: x.GuidelineShortName, standardAnalyteName: x.StandardAnalyteName })
          newList.push({
            Id: x.AnalyteId,
            Name: x.EnviroDataAnalyteName,
            Description: description,
          })
        })

        newList = newList.sort(sortId('Id'))
        this.MasterAnalyteList = JSON.parse(JSON.stringify(newList))
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }

  .keep_space {
    white-space: pre;
  }
</style>